// extracted by mini-css-extract-plugin
export default {"container":"_2oYSu","noSpacing":"_2TEas"};